import { BASE_URL, VENDOR_ASSESSMENT_QUESTION, VENDOR_ASSESSMENT_QUESTION_EXPORT_PDF, VENDOR_ASSESSMENT_QUESTION_EXPORT_EXCEL } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IVendorAssessmentQuestionInput } from "models/vendorAssessmentQuestion";


export async function getVendorAssessmentQuestions(params: string = "") {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_QUESTION + params);
  return response.data;
}
export async function addVendorAssessmentQuestion(data: IVendorAssessmentQuestionInput) {
  const response = await axios.post(BASE_URL + VENDOR_ASSESSMENT_QUESTION, data);
  return response.data;
}
export async function editVendorAssessmentQuestion(data: IVendorAssessmentQuestionInput, id: string) {
  const response = await axios.patch(BASE_URL + VENDOR_ASSESSMENT_QUESTION + "/" + id, data);
  return response.data;
}

export async function deleteVendorAssessmentQuestion(id: string) {
  const response = await axios.delete(BASE_URL + VENDOR_ASSESSMENT_QUESTION + "/" + id);
  return response.data;
}

export async function importExcel(data: FormData, id: string) {
  const response = await axios.post(`${BASE_URL}${VENDOR_ASSESSMENT_QUESTION}/import?definitionId=${encodeURIComponent(id)}`, data);
  return response.data;
}

export async function exportQuestionsPdf(assessmentId: string) {
  const response = await axios.get(`${BASE_URL}${VENDOR_ASSESSMENT_QUESTION_EXPORT_PDF}?vendorAssessmentId=${encodeURIComponent(assessmentId)}`, {
    responseType: 'blob'
  });
  return response.data;
}

export async function exportQuestionsExcel(assessmentId: string) {
  const response = await axios.get(`${BASE_URL}${VENDOR_ASSESSMENT_QUESTION_EXPORT_EXCEL}?vendorAssessmentId=${encodeURIComponent(assessmentId)}`, {
    responseType: 'blob'
  });
  return response.data;
}

export const VendorAssessmentQuestionCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "titleAr",
    numeric: false,
    disablePadding: false,
    label: "T_title_ar",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_ar",
  },
  {
    id: "questionOrder",
    numeric: true,
    disablePadding: false,
    label: "T_question_order",
  },
  {
    id: "questionType",
    numeric: true,
    disablePadding: false,
    label: "T_type",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
